














































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import GroupSearch from '@/app/components/Group/GroupSearch.vue'
import GroupList from '@/app/components/Group/GroupList.vue'
/* api */
import GroupListApi from '@/app/model/api/groupListApi'
/* module */
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    GroupSearch,
    GroupList
  }
})
export default class GroupMaster extends Vue {
  /* データ */
  private groupData: any = {}
  private defaultGroupData: any = {}
  private totalCount: number = 0
  private sort: boolean = true
  private alertText: string = ''
  private alertMessage: string = this.$store.state.alertState.message
  /* 表示非表示 */
  private showGroupSearch: boolean = false
  private notDataMessage: boolean = false
  private isOkGroupList: boolean = false
  private showServerErrorModal: boolean = false
  private showLoading: boolean = true

  created () {
    let stateData = this.$store.state.groupState
    this.getGroupList()
  }

  private getGroupList () {
    (async () => {
      /* 初期表示はグループ名の昇順 */
      let data: any = {
        order_name: this.$store.state.groupState.sortName, // グループ名=1で固定
        sort: this.$store.state.groupState.sortAsc,
        text: this.$store.state.groupState.searchText
      }

      if (data.sort) {
        data.sort = 'asc'
      } else {
        data.sort = 'desc'
      }

      const result = await GroupListApi.getGroupList(data)
      if (result.isOk()) {
        this.totalCount = result.getPayload().total_group
        this.groupData = result.getPayload().groups
        this.defaultGroupData = result.getPayload().groups

        this.isOkGroupList = true
        this.showGroupSearch = true

        if (this.groupData.length === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  /* 検索&ソート */
  private doGroupSearch (name: string) {
    (async () => {
      this.showLoading = true
      // 検索のときは並び順リセット
      if (name === undefined) {
        name = 'group_name'
        this.$store.commit('groupState/setSortAsc', false)
        this.sort = true
      }

      let data : any = {
        order_name: name,
        sort: this.sort,
        text: this.$store.state.groupState.searchText
      }

      /* state保持 */
      if (this.$store.state.groupState.sortAsc) {
        this.$store.commit('groupState/setSortAsc', false)
        data.sort = 'desc'
        this.sort = false
      } else {
        this.$store.commit('groupState/setSortAsc', true)
        data.sort = 'asc'
        this.sort = true
      }
      this.$store.commit('groupState/setSortName', data.order_name)

      const result = await GroupListApi.getGroupList(data)

      if (result.isOk()) {
        this.updateList(result.getPayload().groups)
        this.groupData = result.getPayload().groups
        this.totalCount = result.getPayload().total_group

        this.isOkGroupList = true
        this.showGroupSearch = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private updateList (val: any) {
    this.$store.commit('groupState/setGroupList', val)
    this.groupData = this.$store.state.groupState.groupData

    if (this.groupData.length === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }
  }

  private changeList () {
    let groupList = this.defaultGroupData
    let newList = []
    let text = this.$store.state.groupState.searchText

    for (var i in groupList) {
      if (groupList[i].group_name.indexOf(text) !== -1) {
        newList.push(groupList[i])
      }
    }

    this.totalCount = newList.length
    return newList
  }

  private resetList () {
    this.getGroupList()
  }

  private logout () {
    CommonClass.doLogout()
  }
}
